import React, { createContext, useRef, useState } from "react";
import { LinkProps } from "react-router";

const defaultExternalLinkModalContext = {
  isOpen: false,
  open: () => {},
  close: () => {},
  manualRedirectTo: "",
};

export const ExternalLinkModalContext = createContext<{
  open: (to: LinkProps["to"]) => void;
  isOpen: boolean;
  close: () => void;
  manualRedirectTo: LinkProps["to"];
}>(defaultExternalLinkModalContext);

const TIME_BEFORE_REDIRECT = 5000;

export const ExternalLinkModalProvider = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const [isOpen, setIsOpen] = useState(false);
  const [manualRedirectTo, setManualRedirectTo] = useState<LinkProps["to"]>("");

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const open = (to: LinkProps["to"]) => {
    setIsOpen(true);
    setManualRedirectTo(to);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);

      if (typeof to === "string") {
        window.open(to);
      } else if (to && typeof to === "object") {
        const url = `${to.pathname ?? ""}` + `${to.search ?? ""}` + `${to.hash ?? ""}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }, TIME_BEFORE_REDIRECT);
  };

  const close = () => {
    setIsOpen(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  return (
    <ExternalLinkModalContext.Provider
      value={{
        isOpen,
        close: close,
        open: open,
        manualRedirectTo,
      }}
    >
      {children}
    </ExternalLinkModalContext.Provider>
  );
};
